export default "__VITE_ASSET__83ad8e29__"